const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
const UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const DIGITS = '0123456789';
const CHARSET = LOWERCASE + UPPERCASE + DIGITS;

const DEFAULT_PASSWORD_LENGTH = 12;

const getRandomIndex = (max: number) => crypto.getRandomValues(new Uint32Array(1))[0]! % max;

const getRandomChar = (chars: string) => chars[getRandomIndex(chars.length)]!;

const shuffle = <T>(items: T[]) => {
	const result = [...items];

	for (let i = result.length - 1; i > 0; i -= 1) {
		const j = getRandomIndex(i + 1);
		[result[i], result[j]] = [result[j]!, result[i]!];
	}

	return result;
};

export const generatePassword = (
	length = DEFAULT_PASSWORD_LENGTH,
	minLength = DEFAULT_PASSWORD_LENGTH,
) => {
	const passwordLength = Math.max(length, minLength);
	const required = [getRandomChar(LOWERCASE), getRandomChar(UPPERCASE), getRandomChar(DIGITS)];

	const rest = Array.from({ length: passwordLength - required.length }, () =>
		getRandomChar(CHARSET),
	);

	return shuffle([...required, ...rest]).join('');
};
